import { IconButton } from "@dgs/core";
import { useField } from "formik";
import { FC, useId, useMemo } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ContactAttributeOption, IContactFilterItemRequest } from "../shared/types";
import { ContactFilterColumnEntry } from "./ContactFilterColumnEntry";
import { ContactFilterDataFieldEntry } from "./ContactFilterDataFieldEntry";
import { ContactFilterRelationEntry } from "./ContactFilterRelationEntry";

interface Props {
	name: string;
	options: ContactAttributeOption[];
	onDelete: () => void;
}

const Header = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: ${({ theme }) => theme.spacing(2)} 0;
`;

const Strong = styled.strong`
	font-weight: ${({ theme }) => theme.fonts.weights.bold};
`;

export const ContactFilterEntry: FC<Props> = ({ name, options, onDelete }) => {
	const { t } = useTranslation();
	const [{ value }] = useField<IContactFilterItemRequest>(name);
	const labelId = useId();
	const option = useMemo(
		() => options.find(({ id }) => id === value.contactAttributeId),
		[value.contactAttributeId, options],
	);

	if (!option) {
		return (
			<div>
				<div>Missing attribute for id {value.contactAttributeId}</div>
				<IconButton type="button" title={t("Remove filter entry")} size="small" icon="delete" onClick={onDelete} />
			</div>
		);
	}

	return (
		<section aria-labelledby={labelId}>
			<Header>
				<Strong id={labelId}>{option.name}</Strong>
				<IconButton type="button" title={t("Remove filter entry")} size="small" icon="delete" onClick={onDelete} />
			</Header>
			{option.attribute.type === "relation" && <ContactFilterRelationEntry name={name} attribute={option.attribute} />}
			{option.attribute.type === "column" && <ContactFilterColumnEntry name={name} attribute={option.attribute} />}
			{option.attribute.type === "dataField" && (
				<ContactFilterDataFieldEntry name={name} attribute={option.attribute} />
			)}
		</section>
	);
};
